
import axios from '../wmsAxios'

/*
 * 全局Source管理
 */

// 获取RF界面数据
export const getRfDialogForm = (data) => {
  return axios({
    url: '/rfDialog/getRfDialogForm',
    method: 'post',
    data
  })
}

// 提交RF界面数据
export const confirmRfDialog = (data) => {
  return axios({
    url: '/rfDialog/confirmRfDialog',
    method: 'post',
    data
  })
}

// 获取功能键的跳转界面
export const getRfFunctionProcess = (data) => {
  return axios({
    url: '/rfDialog/getRfFunctionProcess',
    method: 'post',
    data
  })
}

// 获取下拉列表数据
export const getRfDialogList = (data) => {
  return axios({
    url: '/rfDialog/getRfDialogList',
    method: 'post',
    data
  })
}

// 绑定user和叉车
export const bindRfUserFork = (data) => {
  return axios({
    url: '/rfDialog/bindRfUserFork',
    method: 'post',
    data
  })
}

// 解绑user和叉车
export const unbindRfUserFork = (data) => {
  return axios({
    url: '/rfDialog/unbindRfUserFork',
    method: 'post',
    data
  })
}

// 获取用户进行中的进程
export const getCurrentProcessPerUser = (data) => {
  return axios({
    url: '/rfDialog/getCurrentProcessPerUser',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/rfDialog.js